import { render, staticRenderFns } from "./ActionBtnsTitle.vue?vue&type=template&id=738cae88&scoped=true&"
import script from "./ActionBtnsTitle.vue?vue&type=script&lang=js&"
export * from "./ActionBtnsTitle.vue?vue&type=script&lang=js&"
import style0 from "./ActionBtnsTitle.vue?vue&type=style&index=0&id=738cae88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738cae88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
